import apiClient from '../apiClient';
import { POST_DEMO_MANUAL_PAYMENT_URL } from '../apiUrl';

const postDemoManualPaymentApi = data => {
  return apiClient.post(POST_DEMO_MANUAL_PAYMENT_URL, data);
};

export default postDemoManualPaymentApi;
